function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg158Tokelau(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "210.715,174.377 214.399,185.715 226.318,185.715 216.675,192.721 220.359,204.058    210.715,197.051 201.071,204.058 204.755,192.721 195.11,185.715 207.031,185.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "116.816,281.971 121.421,296.143 136.321,296.143 124.266,304.9 128.872,319.073    116.816,310.313 104.761,319.073 109.365,304.9 97.311,296.143 112.21,296.143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "144.696,119.679 149.3,133.851 164.201,133.851 152.145,142.609 156.751,156.78    144.696,148.021 132.64,156.78 137.246,142.609 125.191,133.851 140.091,133.851  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "69.539,175.331 74.143,189.503 89.043,189.503 76.988,198.261 81.594,212.432    69.539,203.674 57.483,212.432 62.089,198.261 50.034,189.503 64.934,189.503  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M483.386,354.503H117.801c0,0,109.234-88.562,310.593-220.938   C428.395,133.565,339.951,262.5,483.386,354.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M117.801,366.089c-11.177,0-11.195,17.37,0,17.37h365.585c11.177,0,11.195-17.37,0-17.37H117.801z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg158Tokelau);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };